import { useQuickPostV3ModalStore } from "@circle-react/components/QuickPostV3/store";
import { Button } from "@circleco/compass/components/Button";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

export const SettingsHeader = () => {
  const goToComposer = useQuickPostV3ModalStore(state => state.goToComposer);

  return (
    <header
      className="flex shrink-0 flex-col px-6 pb-0 pt-6"
      data-testid="quick-post-v3-settings-header"
    >
      <div className="mb-3 flex w-full flex-row items-center gap-4">
        <IconButton
          aria-label={t("previous")}
          icon="arrow-left"
          onClick={goToComposer}
          size="sm"
          type="button"
          variant="outline"
        />
        <Typography
          className="min-w-0 truncate"
          color="primary"
          variant="heading-lg"
        >
          {t("quick_post_v3.settings.title")}
        </Typography>
        <Button
          className="ml-auto"
          onClick={goToComposer}
          size="md"
          type="button"
          variant="primary"
        >
          {t("quick_post_v2.done")}
        </Button>
      </div>
    </header>
  );
};
